<template>
  <div>
    <events-filter :colour="colour" @filterEvents="filterEvents"></events-filter>

    <div class="container">
      <div class="events">
        <h2>Forthcoming {{ orgname }} events</h2>

        <div>
          <!-- <event-deck :colour="colour" v-if="pageEvents.length > 0"
            :events="pageEvents.length >= 6 ? pageEvents.slice(0, 6) : pageEvents.slice(0)"></event-deck> -->
          <event-deck :events="events" :colour="colour"></event-deck>
          <h3 v-if="events.length == 0">No Events found.</h3>
        </div>

        <!-- <b-pagination v-if="events.length > 0" size="md" :total-rows="events_count"
          :current-page="currentPage" @change="getOrgEvents" class="customPagination"
          v-model="currentPage" :per-page="6">
        </b-pagination> -->

      </div>
    </div>
  </div>

</template>

<script>
import eventDeck from "./events-card-deck.vue";
import eventsFilter from "./events-filter.vue"

export default {
  data() {
    return {
      events: [],
      eventsOld: [],
      currentPage: 1,
      filter: {
        title: "",
        date_on: null,
        location: null,
        tag: null,
        type: null,
        cost: 'all'
      },
      events_count: 0,
      apiToken: null,
      legacyUrl: null,
    };
  },

  props: ['orgid', 'orgname', 'colour'],

  created() {
    this.legacyUrl = document.querySelector('[name=legacy-eventstop-url]').content
    var params = new URLSearchParams(window.location.search);
    this.apiToken = params.get('token');
    this.getOrgEvents();
  },

  methods: {
    filterEvents(filter) {
      this.filter = filter;
      this.getOrgEvents();
    },

    getOrgEvents(page = 1) {
      var self = this;

      if (page) {
        self.currentPage = page;
      }

      this.$http
        .get(`/organisation/${self.orgid}/event_details`, {
          params: {
            title: self.filter.title,
            date_on: self.filter.date_on,
            location: self.filter.location,
            tag: self.filter.tag,
            type: self.filter.type,
            cost: self.filter.cost
          }
        })
        .then(function (response) {
          console.log(response.data);
          self.events = response.data.events;
          self.events_count = response.data.events_count;

          // Do it this way to avoid a chase issue meaning no old events
          self.getOldOrgEvents();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getOldOrgEvents(){  
      var self = this;
      var config = {
          headers: {'Authorization': "Bearer " + this.apiToken},
          params: {
              title: self.filter.title,
              date_on: self.filter.date_on,
              location: self.filter.location,
              tag: self.filter.tag,
              type: self.filter.type,
              cost: self.filter.cost
          }
      }

      this.$http
        .get(`${this.legacyUrl}/api/v1/widget_events/public_events`, config)
        .then(function(response) {
          self.eventsOld = response.data.events || [];
          self.events = self.eventsOld.concat(self.events);

          // self.events_count = response.data.events_count;
          // self.totalPages = Math.ceil(response.data.events_count / 6)
          // self.brand_colour = response.data.filter_colour;
        })
        .catch(function(error) {
          console.log(error);
        });
    },

   
  },
  components: {
    eventDeck: eventDeck,
    eventsFilter: eventsFilter
  },

  // computed: {
  //   pageEvents() {
  //     let start = (this.currentPage - 1) * 6;
  //     let end = (this.currentPage * 6);
  //     if (this.currentPage * 6 <= this.events.length) {
  //       return this.events.slice(start, end)
  //     } else {
  //       return this.events.slice(start)
  //     }
  //   },
  // }

};
</script>

<style>

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: gray;
  border-color: gray;
}

</style>